var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("term.drillProgress"))),
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "subtitle" }, [_vm._v(_vm._s(_vm.service.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-6" }, [
      _c(
        "ul",
        { staticClass: "is-flex is-flex-wrap-wrap custom-flex-container" },
        _vm._l(_vm.posts, function (post, index) {
          return _c(
            "li",
            {
              key: post.postId,
              staticClass: "list-cell",
              class: {
                "has-background-success": _vm.masteredPostIds.includes(
                  post.postId
                ),
              },
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "is-block is-size-5",
                  class: {
                    "has-text-white": _vm.masteredPostIds.includes(post.postId),
                  },
                  attrs: { to: `/posts/${_vm.service.serviceId}/${post.slug}` },
                },
                [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]
              ),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }